export const WeekConstants = {
  days: [
    { dayNumber: 1, dayName: 'Monday' },
    { dayNumber: 2, dayName: 'Tuesday' },
    { dayNumber: 3, dayName: 'Wednesday' },
    { dayNumber: 4, dayName: 'Thursday' },
    { dayNumber: 5, dayName: 'Friday' },
    { dayNumber: 6, dayName: 'Saturday' },
    { dayNumber: 7, dayName: 'Sunday' }
  ]
};
